import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createBlock(_component_v_window, {
    modelValue: _ctx.step,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step) = $event)),
    style: {"width":"40vw"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_window_item, { value: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            elevation: "0",
            class: "px-4 my-4",
            style: {"background-color":"white","border-radius":"25px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "text-h6 mx-auto" }, {
                default: _withCtx(() => [
                  (_ctx.isCreditNote)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Vous allez valider votre premier avoir. Choisissez votre règle de reinitialisation du compteur de votre chrono des avoirs. "))
                    : (_ctx.isQuote)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Vous allez valider votre premier devis. Choisissez votre règle de reinitialisation du compteur de votre chrono des devis. "))
                      : (_ctx.isBillOfDelivery)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Vous allez valider votre premier bon de livraison. Choisissez votre règle de reinitialisation du compteur de votre chrono des bon de livraison. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, " Vous allez valider votre première facture. Choisissez votre règle de reinitialisation du compteur de votre chrono des factures. "))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.data.resetChronoCondition,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.resetChronoCondition) = $event)),
                    inline: "",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_radio, _mergeProps({
                            label: "Aucun",
                            value: "NONE"
                          }, props), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Le compteur de votre chrono ne se réinitialisera jamais.", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_radio, _mergeProps({
                            label: "Mensuel",
                            value: "MONTH"
                          }, props), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[5] || (_cache[5] = _createElementVNode("span", null, "Le compteur de votre chrono se réinitialisera à 1 tout les mois", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_radio, _mergeProps({
                            label: "Annuel",
                            value: "YEAR"
                          }, props), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[6] || (_cache[6] = _createElementVNode("span", null, "Le compteur de votre chrono se réinitialisera à 1 tout les ans", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, { value: 2 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            elevation: "0",
            class: "px-4 my-4",
            style: {"background-color":"white","border-radius":"25px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_subtitle, { class: "d-flex justify-end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_icon, _mergeProps({ color: "secondary" }, props), {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("$oss-help")
                        ])),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(() => [
                      _cache[12] || (_cache[12] = _createElementVNode("span", null, [
                        _createElementVNode("strong", null, "Formatage du chrono de facturation"),
                        _createElementVNode("br")
                      ], -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("span", null, [
                        _createTextVNode("Ce qui doit être présent obligatoirement: "),
                        _createElementVNode("br")
                      ], -1)),
                      _cache[14] || (_cache[14] = _createElementVNode("span", null, [
                        _createTextVNode("- Le compteur de factures = \"X\""),
                        _createElementVNode("br")
                      ], -1)),
                      (_ctx.data.resetChronoCondition !== 'NONE')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _cache[8] || (_cache[8] = [
                            _createTextVNode("- Année au format long = \"YYYY\""),
                            _createElementVNode("br", null, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      (_ctx.data.resetChronoCondition === 'MONTH')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _cache[9] || (_cache[9] = [
                            _createTextVNode("- Mois = \"MM\" pour afficher le mois"),
                            _createElementVNode("br", null, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      _cache[15] || (_cache[15] = _createElementVNode("span", null, [
                        _createElementVNode("br"),
                        _createTextVNode("Ce que vous pouvez saisir:"),
                        _createElementVNode("br")
                      ], -1)),
                      (_ctx.data.resetChronoCondition === 'NONE')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[10] || (_cache[10] = [
                            _createTextVNode("- Année au format long = \"YYYY\""),
                            _createElementVNode("br", null, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      _cache[16] || (_cache[16] = _createElementVNode("span", null, [
                        _createTextVNode("- Année au format court = \"YY\""),
                        _createElementVNode("br")
                      ], -1)),
                      (_ctx.data.resetChronoCondition !== 'MONTH')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _cache[11] || (_cache[11] = [
                            _createTextVNode("- Mois = \"MM\" pour afficher le mois"),
                            _createElementVNode("br", null, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      _cache[17] || (_cache[17] = _createElementVNode("span", null, [
                        _createTextVNode("- Jour = \"DD\" pour afficher le jour"),
                        _createElementVNode("br")
                      ], -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "text-h6 mx-auto" }, {
                default: _withCtx(() => [
                  (_ctx.isCreditNote)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Veuillez spécifier la nomenclature du chrono de vos avoir. "))
                    : (_ctx.isQuote)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Veuillez spécifier la nomenclature du chrono de vos devis. "))
                      : (_ctx.isBillOfDelivery)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Veuillez spécifier la nomenclature du chrono de vos bon de livraison. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, "Veuillez spécifier la nomenclature du chrono de vos facture."))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "d-flex flex-column align-start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    label: "Chrono",
                    modelValue: _ctx.data.chrono,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.chrono) = $event)),
                    style: {"width":"100%"},
                    error: _ctx.isChronoError,
                    "error-messages": _ctx.chronoError,
                    "hide-details": false
                  }, null, 8, ["modelValue", "error", "error-messages"]),
                  _createElementVNode("p", null, "Exemple: " + _toDisplayString(_ctx.chronoExample), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, { value: 3 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            elevation: "0",
            class: "px-4 my-4",
            style: {"background-color":"white","border-radius":"25px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "text-h6 mx-auto" }, {
                default: _withCtx(() => [
                  (_ctx.isCreditNote)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, " C'est votre premier avoir" + _toDisplayString(_ctx.timeMessage) + ". A combien voulez-vous commencer le compteur des avoirs. ", 1))
                    : (_ctx.isQuote)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, " C'est votre premier devis" + _toDisplayString(_ctx.timeMessage) + ". A combien voulez-vous commencer le compteur des devis. ", 1))
                      : (_ctx.isBillOfDelivery)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " C'est votre premier bon de livraison" + _toDisplayString(_ctx.timeMessage) + ". A combien voulez-vous commencer le compteur des bon de livraison. ", 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_16, " C'est votre première facture" + _toDisplayString(_ctx.timeMessage) + ". A combien voulez-vous commencer le compteur des factures. ", 1))
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "d-flex flex-column align-start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field_filled, {
                    label: "compteur",
                    type: "number",
                    modelValue: _ctx.data.counter,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.counter) = $event)),
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("p", null, "Exemple: " + _toDisplayString(_ctx.chronoExample), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_window_item, { value: 4 }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            elevation: "0",
            class: "px-4 my-4",
            style: {"background-color":"white","border-radius":"25px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "text-h6 mx-auto" }, {
                default: _withCtx(() => [
                  (_ctx.isRecurent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Voulez-vous vraiment valider cette facture réccurente ? Cette action ne pourra pas être annulée "))
                    : (_ctx.isInvoiceMatrix)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Voulez-vous vraiment valider toutes les fatures? Cette action ne pourra pas être annulée "))
                      : (_ctx.isCreditNote)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Voulez-vous vraiment valider cet avoir ? Cette action ne pourra pas être annulée "))
                        : (_ctx.isQuote)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Voulez-vous vraiment valider ce devis ? Cette action ne pourra pas être annulée "))
                          : (_ctx.isBillOfDelivery)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Voulez-vous vraiment valider ce bon de livraison ? Cette action ne pourra pas être annulée "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_22, " Voulez-vous vraiment valider cette facture ? Cette action ne pourra pas être annulée "))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}